import React from "react";
import { connect } from "react-redux";
import { Table, Tab } from "semantic-ui-react";
import _ from "lodash";
import DeathRecordDetail from "./DeathRecordDetail";
import ResultHeader from "./ResultHeader";
import "../../assets/styles/sub-table.css";
import { getMenuItem } from "../common/PageHelper";

class DeathRecordsResult extends React.Component {
  constructor(props) {
    super(props);
    this.loadData(props);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  loadData = (props) => {
    const results = [];
    let tabHeader;
    let resultsCount = 0;
    if (
      props.searchResultData !== undefined &&
      props.searchResultData !== null &&
      props.searchResultData !== ""
    ) {
      let resultNodes = _.get(
        props.searchResultData,
        "response.output[0].people[0].person[0]"
      );
      if (resultNodes === undefined) {
        resultNodes = _.get(
          props.searchResultData,
          "deathrecords.response[0].result"
        );
      }
      const showNarrowSearchMessage =
        resultNodes !== undefined && resultNodes.length > 25;
      tabHeader = (
        <ResultHeader
          showNarrowSearchMessage={showNarrowSearchMessage}
          {...this.props}
        />
      );

      if (resultNodes)
        _.forEach(resultNodes, (node, index) => {
          const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
          const status = _.get(node, "status[0]._", "");
          if (status && status === "DECEASED" && _.get(node, "deceased") !== undefined) {
            results.push(
              <Table.Row key={`Deceased_Row_${index}`} className={colorClass}>
                <Table.Cell>
                  <DeathRecordDetail node={node} {...this.props} />
                </Table.Cell>
              </Table.Row>
            );
          }
          if (!status && _.get(node, "[0].$.display") === "Deceased" && _.get(node, "[0]._") === "Yes") {
            results.push(
              <Table.Row key={`Deceased_Row_${index}`} className={colorClass}>
                <Table.Cell>
                  <DeathRecordDetail node={resultNodes} {...this.props} />
                </Table.Cell>
              </Table.Row>
            );
          }
        });
      resultsCount = results.length;
    }
    this.state = {
      results,
      resultsCount,
      tabHeader,
    };
  };

  render() {
    const tabs = [];
    const { userAccount } = this.props;
    tabs.push({
      menuItem: getMenuItem(
        userAccount.acctTheme,
        true,
        `${this.state.resultsCount} Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          {this.state.tabHeader}
          {this.state.results.length > 0 && (
            <Table stackable>
              <Table.Body>{this.state.results}</Table.Body>
            </Table>
          )}
        </Tab.Pane>
      ),
    });
    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(DeathRecordsResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/DeathRecordsResult.js